export class SessionNotFoundException extends Error {
	constructor(message = 'No session found') {
		super(message);
		this.name = 'SessionNotFoundException';
	}
}
